<template>
  <div class="container-fluid">
    <div class="row listBar">
      <div class="col">
        <div class="Attentions">關注列表</div><div class="Arrangement">時間排序</div>
      </div>
    </div>
    <div class="row Attentions" v-for="(Attention, index) in Attentions" :key="(Attention, index)" @click="Shop(Attention.shopId)">
      <hr>
      <div class="col shopName"><div>{{ Attention.shopName }}</div></div>
      <div class="col updateTime"><div>{{ $moment(updateTime).format("YYYY-MM-DD HH:mm") }}</div></div>
    </div>
    <div class="row FooterSpace"></div>
    <div class="row Footer">
      <div class="col">
        <button class="btn" @click="Home()">
          <i class="fas fa-home"></i><br><span>首頁</span>
        </button>
      </div>
      <div class="col">
        <button class="btn" @click="User()">
          <i class="fa-solid fa-user"></i><br><span>會員資料</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { getUserAttentions } from '@/Service/APIService'

export default {
  name: "Attentions",
  data() {
    return {
      Attentions: null // 消費者關注列表
    }
  },
  methods: {
    /* 初始化，取得消費者關注列表 */
    init: async function() {
      const response = await getUserAttentions()

      this.$data.Attentions = response.data
    },
    /* 前往店家頁面 */
    Shop: function(id) {
      this.$router.push({ path: `/Shop/${id}` })
    },
    /* 前往首頁頁面 */
    Home: function() {
      this.$router.push({ name: `Home` })
    },
    /* 前往會員資料頁面 */
    User: function() {
      this.$router.push({ name: `User` })
    },
  },
  mounted() {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.container-fluid, .row {
  margin: 0px;
  padding: 0px;
  > .listBar {
    margin: 0px;
    padding: 10px 0px;
    background-color: #87CEFAAA;
    color: #000000;
    text-shadow: 1px 1px 0 #FFFFFF;
    font-size: 18px;
    font-weight: 900;
    > .col {
      > .Attentions {
        float: left;
        padding-left: 15px;
      }
      > .Arrangement {
        float: right;
        padding-right: 15px;
        > .Arrow {
          margin-left: 10px;
        }
      }
    }
  }
  > .Attentions {
    margin-bottom: 10px;
    font-weight: bold;
    > .shopName {
      padding-left: 25px;
    }
    > .updateTime {
      text-align:right;
      padding-right: 15px;
    }
  }
> .FooterSpace {
    height: 70px;
  }
  > .Footer {
    position: fixed;
    bottom: 0;
    text-align: center;
    width: 100%;
    height: 70px;
    background-color: #5599FF;
    > .col {
      > .btn {
        border: 0px;
        background-color: #5599FF;
        box-shadow: 0px 0px 0px 0px;
        color: #FFFFFF;
        font-size: 20px;
        font-weight: 900;
        > .fas {
          margin-bottom: 3px;
          font-size: 24px;
        }
      }
    }
  }
}
</style>